/**
 * A redux-based replacement to the backbone model
 * file envHooks.js that calls various hooks at
 * key times for for external routes.
 */

// we need to store the env to trigger with it later
let env = ''
const manuallyRegisteredHooks = {}

/**
 * Dispatch anything called 'externalHook:<name>' and
 * we'll make sure the correct hook is triggered
 */
const processExternalHooks = store => next => action => {
  // save the current environment
  if (!env) {
    env = store.getState().server.env
  }

  // dynamically register hooks
  // TODO: take an env?
  if (action.type === 'registerExternalHooks') {
    Object.assign(manuallyRegisteredHooks, action.data)
  }

  // dispatch hooks
  if (action.type.match(/externalHook:/)) {
    const [, hook] = action.type.split(':')
    trigger(`${hook}Hook`, action.data, store.getState())
  }

  // always just pass everything through
  return next(action)
}

function trigger(hook, data, state) {
  // we do this to avoid a circular dependency
  require(['../hooks/index'], ({ hooks }) => {
    // override static environment hook with manually reigstered hooks
    const envHooks = { ...hooks[env], ...manuallyRegisteredHooks }
    if (typeof envHooks[hook] === 'function') {
      envHooks[hook](data, state)
    }
  })
}

export default processExternalHooks
